import React, {useEffect, useMemo, useState} from "react";
import {ACard, ACheckboxElement,} from "@atiautomacao/ati-ui-library";
import {useAppSelector} from "../../../Config/Hooks";
import Button from "@mui/material/Button";
import {format} from 'date-fns';
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {DatePicker} from "@mui/x-date-pickers/DatePicker";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import TextField from "@mui/material/TextField";
import {
    Box,
    Checkbox,
    FormControl,
    FormControlLabel,
    Grid,
    Modal,
    OutlinedInput,
    Radio,
    RadioGroup,
    Select,
    Typography
} from "@mui/material";
import {Download} from "@mui/icons-material";
import {LocalDateTimeFormatISO} from "../../../Utils/DateFormatPatternUtils";
import InputLabel from "@mui/material/InputLabel";
import ListItemText from "@mui/material/ListItemText";
import MenuItem from "@mui/material/MenuItem";
import {postAndDownloadReportFile, downloadReportFile} from "./utils/postAndDownloadFile";
import {
    MANAGEMENT_OVERVIEW_POPUP_BLOCKED_MESSAGE,
} from "./Overview/types/ManagementOverviewReport.types";
import {
    isAuthorizedForManagementOverviewReport,
    openManagementOverviewPrintTab,
} from "./Overview/utils/managementOverviewRoute";
import {ManagementReportSkidsConcated, SubReportHeader, SubReportHeaderByEquipmentInverter, SubReportHeaderBySkid, useSubReportHeaderPowerStationQuery} from "./types/ManagementReportBySkidReactQuery";
import { buildForPowerStation, buildForSkid, buildForEquipment } from "./utils/SubHeaderListBuilder";
import {QueryClient, QueryClientProvider} from "react-query";
import {useSnackbar} from "notistack";
import SaveIcon from "@mui/icons-material/Save";
import {LoadingButton} from "@mui/lab";
import SelectAllTransferList, {SubHeader} from "./Shuttle";
import {hasPermission} from "../../../Shared/Auth/AuthenticationUtil";
import {AUTHORITIES} from "../../../Config/Constants";
export interface CustomElement {
    data? : {
        id : number
    } | object
}
type MyElement = CustomElement & ACheckboxElement;


const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 450,
        },
    },
};

function ManagementReport() {
    const { enqueueSnackbar } = useSnackbar();
    const account = useAppSelector(state => state.authentication.account);
    const isAuthorizedToSearchByPdf = hasPermission(account?.authoritySet, [
        AUTHORITIES.SYSADMIN, AUTHORITIES.VIEW_PDF_EXPORT, AUTHORITIES.EXPORT_REPORT_MANAGEMENT_REPORT, AUTHORITIES.PDF_EXPORT_REPORT_MANAGEMENT_REPORT
    ]);
    const isAuthorizedForOverviewReport = isAuthorizedForManagementOverviewReport(account?.authoritySet);
    const isAuthorizedToSearchByCsv = hasPermission(account?.authoritySet, [
        AUTHORITIES.SYSADMIN, AUTHORITIES.VIEW_CSV_EXPORT, AUTHORITIES.EXPORT_REPORT_MANAGEMENT_REPORT, AUTHORITIES.CSV_EXPORT_REPORT_MANAGEMENT_REPORT
    ]);
    const isAuthorizedToSearchByExcel = hasPermission(account?.authoritySet, [
        AUTHORITIES.SYSADMIN, AUTHORITIES.VIEW_EXCEL_EXPORT, AUTHORITIES.EXPORT_REPORT_MANAGEMENT_REPORT, AUTHORITIES.EXCEL_EXPORT_REPORT_MANAGEMENT_REPORT
    ]);

    const { data } = ManagementReportSkidsConcated();
    const [typeManagement, setTypeManagement] = React.useState<'overview' | 'powerStation' | 'skid' | 'inverter'>("overview");
    const isPdfActionEnabled =
        typeManagement === 'overview' ? isAuthorizedForOverviewReport : isAuthorizedToSearchByPdf;

    const subHeader = useSubReportHeaderPowerStationQuery();

    const handleStartDateTime = (newValue: Date) => {
        const firstDayOfMonth = new Date(newValue.getFullYear(), newValue.getMonth(), 1);
        firstDayOfMonth.setHours(0, 0, 0, 0);

        return firstDayOfMonth;

    };

    const [open, setOpen] = React.useState(false);
        // close modal
        const handleCloseModal = () => {
            setOpen(false);
        }
    const [subHeaderList, setSubHeaderList] = useState<SubReportHeader | SubReportHeaderBySkid | SubReportHeaderByEquipmentInverter>();
    const [dataShuttle, setDataShuttle] = useState<SubHeader[]>([]);
    const [checked, setChecked] = useState<Array<ACheckboxElement>>([]);
    const [checkedAll, setCheckedAll] = React.useState(false);
    const [startDateTime, setStartDateTime] = React.useState<Date>(handleStartDateTime(new Date()));
    const [endDateTime, setEndDateTime] = React.useState<Date>(new Date());
    const [groupedByPeriod, setGroupedByPeriod] = React.useState<string>( "day");
  
    const [selectedSkidList, setSelectedSkidList] = useState<Array<{ id: number, name: string,equipmentList:{id: number; name: string }[] }>>([]);
    const [concatenatedSkids, setConcatenatedSkids] = useState<{ id: number, name: string,equipmentList:{ id: number; name: string }[] }[]>([]);
    const [checkedSkids, setCheckedSkids] = useState<{ name: string; checked: boolean; data: { id: number; name: string,equipmentList:{ id: number; name: string  }[] } }[]>([]);
    const [checkedAllSkid, setCheckedAllSkid] = React.useState(false);

    const [selectedInverterList, setSelectedInverterList] = useState<Array<{ id: number, name: string,checked: boolean,equipmentType: { id: number; name: string } }>>([]);
    const [concatenatedInverters, setConcatenatedInverters] = useState<Array<{ id: number, name: string }>>([]);
    const [checkedInverters, setCheckedInverters] = useState<
        { name: string; checked: boolean; data: { id: number; name: string } }[]>([]);
    const [checkedAllInverter, setCheckedAllInverter] = React.useState(false);

    const [isDownloadCsv, setIsDownloadCsv] = useState(false);
    const [isDownloadPdf, setIsDownloadPdf] = useState(false);
    const [isDownloadExcel, setIsDownloadExcel] = useState(false);
    const getSkidNameWithPowerStationName = (skid: { id: any; name: any; equipmentList: { id: number; name: string }[] }, powerStationList: any[]) => {
        const station = powerStationList.find((powerStation: any) =>
            powerStation.skidList.some((s: any) => s.id === skid.id)
        );
        return station ? `${skid.name}` : skid.name;
    };
    useEffect(() => {
        const listPowerStations = new Array<ACheckboxElement>();
        if(data){
            data.data.forEach((element: { name: any; }, index: number) => {
                listPowerStations.push({label: element.name, checked: index === 0, data: element});
            });
        }
        setChecked(listPowerStations)
    }, [data]);

    const memoizedConcatenatedSkids = useMemo(() => {
        return selectedSkidList.map(skid => ({
            id: skid.id,
            name: getSkidNameWithPowerStationName(skid, data?.data || []),
            equipmentList: skid.equipmentList
        }));
    }, [selectedSkidList, data]);


    const concatedSkidsForSelector = (): { data: { id: number; name: string, equipmentList: { id: number; name: string }[] }; name: string; checked: boolean }[] => {
        return concatenatedSkids.map((element) => {
            return {name: element.name, checked: false, data: element};
        });
    }

    useEffect(() => {
        setCheckedSkids(concatedSkidsForSelector());
    }, [concatenatedSkids]);


    useEffect(() => {
        setCheckedAll(checked.every(item => item.checked));
    }, [checked]);

    useEffect(() => {
        setCheckedAllSkid(checkedSkids.every(item => item.checked));
    }, [checkedSkids]);

    useEffect(() => {
        setConcatenatedSkids(memoizedConcatenatedSkids);
    }, [memoizedConcatenatedSkids]);

    useEffect(() => {
        const selectedSkids = checked
            .filter(item => item.checked && item.data && (item.data as any).skidList)
            .flatMap(item => (item.data as any).skidList);
        setSelectedSkidList(selectedSkids);
    }, [checked]);

    const handleChangeAllCheckbox = (event: React.ChangeEvent<HTMLInputElement>) => {
        setChecked(checked.map(item => {
            return { ...item, checked: event.target.checked };
        }));
        setCheckedAll(event.target.checked);
    };

    const handleChangeElementCheckbox = (event: React.ChangeEvent<HTMLInputElement>, index: number) => {
        let updatedChecked = [...checked];
        updatedChecked[index].checked = event.target.checked;
        setChecked(updatedChecked);
    };

    const handleChangeAllSkidCheckbox = (event: React.ChangeEvent<HTMLInputElement>) => {
        setCheckedSkids(checkedSkids.map(item => {
            return { ...item, checked: event.target.checked };
        }));
        setCheckedAllSkid(event.target.checked);
    };

    const handleChangeSkidCheckbox = (event: React.ChangeEvent<HTMLInputElement>, index: number) => {
        let updatedCheckedSkids = [...checkedSkids];
        updatedCheckedSkids[index].checked = event.target.checked;
        setCheckedSkids(updatedCheckedSkids);
    };

    useEffect(() => {
        const selectedInverters = checkedSkids
            .filter(item => item.checked && item.data && (item.data as any).equipmentList)
            .flatMap(item => (item.data as any).equipmentList);

        setSelectedInverterList(selectedInverters.filter(inverter => inverter.equipmentType.id === 2));
    }, [checkedSkids]);

    // Equipments

    const getInverterNameWithSkidName = (equipment:{id: any; name: string; checked: boolean; equipmentType: { id: number; name: string }}, powerStationList: any[]) => {
        let nameEquipment = '';
        powerStationList.find(powerStation => {
            const skid = powerStation.skidList.find((skid: any) =>
                skid.equipmentList.some((equip: any) => equip.id === equipment.id && equipment.equipmentType?.id === 2)
            );
            if (skid) {
                nameEquipment = `${equipment.name}`;
                return powerStation;
            }
        })
        return nameEquipment;
    }

    const memoizedConcatenatedInverters = useMemo(() => {
        return selectedInverterList.map(equipment => ({
            id: equipment.id,
            name: getInverterNameWithSkidName(equipment, data?.data || []),
        }));
    }, [selectedSkidList,selectedInverterList, data]);

    useEffect(() => {
        setConcatenatedInverters(memoizedConcatenatedInverters);
    }, [memoizedConcatenatedInverters]);

    const concatenatingInverterForSelector = (): { data: { id: number; name: string }; name: string; checked: boolean }[] => {
        return concatenatedInverters.map((element) => {
            return {name: element.name, checked: false, data: element};
        });
    }

    useEffect(() => {
        setCheckedInverters(concatenatingInverterForSelector());
    }, [concatenatedInverters]);

    const handleChangeAllInverterCheckbox = (event: React.ChangeEvent<HTMLInputElement>) => {
        setCheckedInverters(checkedInverters.map(item => {
            return { ...item, checked: event.target.checked };
        }));
        setCheckedAllInverter(event.target.checked);
    };

    const handleChangeInverterCheckbox = (event: React.ChangeEvent<HTMLInputElement>, index: number) => {
        let updatedCheckedInverters = [...checkedInverters];
        updatedCheckedInverters[index].checked = event.target.checked;
        setCheckedInverters(updatedCheckedInverters);
    };


    const handlePeriodChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setGroupedByPeriod((event.target as HTMLInputElement).value);
    };

    const handleTypeManagement = (event: React.ChangeEvent<HTMLInputElement>) => {
        setTypeManagement((event.target as HTMLInputElement).value as 'overview' | 'powerStation' | 'skid' | 'inverter');
    };

    const getFileName = (groupedByPeriod: string, extension: string) => {
        let period;
        switch (groupedByPeriod) {
            case "year":
                period = 'anual';
                break;
            case "month":
                period = 'mensal';
                break;
            case "week":
                period = 'semanal';
                break;
            default:
                period = 'diario';
        }
        return `relatorio_de_gestao_${period}.${extension}`;
    }

    const handlePdfDownload = () => {
        setOpen(true);
    }

    const handlePdfDownloadGraphicalManagementReport = () => {
        const powerStationIds = checked
            .filter(entity => entity.checked)
            .map(entity => (entity?.data as { id: number }).id);

        const opened = openManagementOverviewPrintTab({
            powerStationIds,
            endDateTime: LocalDateTimeFormatISO(endDateTime),
        });

        if (!opened) {
            enqueueSnackbar(MANAGEMENT_OVERVIEW_POPUP_BLOCKED_MESSAGE, { variant: 'warning' });
        }
    }

    const handlePdfDownloadManagementReportSkid = (managementSubReportHeader: SubReportHeader) => {
        let apiUrl;
        switch (groupedByPeriod) {
            case "year":
                apiUrl = `api/management-data/skid/pdf/year`
                break;
            case "month":
                apiUrl = `api/management-data/skid/pdf/month`
                break;
            case "week":
                apiUrl = `api/management-data/skid/pdf/week`
                break;
            default:
                apiUrl = `api/management-data/skid/pdf/day`
        }
        const data = {
            skidIdsList: checkedSkids.filter(entity => entity.checked).map(entity => (entity?.data as {
                id: number
            }).id),
            startDateTime: format(new Date(startDateTime), 'yyyy-MM-dd') + 'T00:00:00',
            endDateTime: LocalDateTimeFormatISO(endDateTime),
            managementSubReportHeader: managementSubReportHeader

        }

        setIsDownloadPdf(true);


        postAndDownloadReportFile(apiUrl, data, getFileName(groupedByPeriod, 'pdf'), () => {
                enqueueSnackbar("Sucesso ao baixar o PDF por skid", {variant: 'success'});
                setIsDownloadPdf(false);
            }, (error) => {
                enqueueSnackbar("Erro ao baixar o PDF por skid" + error, {variant: 'error'});
                setIsDownloadPdf(false);
            },
            () => {
                enqueueSnackbar("Dados não encontrados para esse período", {variant: 'warning'});
                setIsDownloadPdf(false);
            }
        );

    }
    const handlePdfDownloadManagementReportInverter = (managementSubReportHeader: SubReportHeader) => {
        let apiUrl;
        switch (groupedByPeriod) {
            case "year":
                apiUrl = `api/management-data/inverter/pdf/year`
                break;
            case "month":
                apiUrl = `api/management-data/inverter/pdf/month`
                break;
            case "week":
                apiUrl = `api/management-data/inverter/pdf/week`
                break;
            default:
                apiUrl = `api/management-data/inverter/pdf/day`
        }
        const data = {
            equipmentIdsList: checkedInverters.filter(entity => entity.checked).map(entity => (entity?.data as {
                id: number
            }).id),
            startDateTime: format(new Date(startDateTime), 'yyyy-MM-dd') + 'T00:00:00',
            endDateTime: LocalDateTimeFormatISO(endDateTime),
            managementSubReportHeader: managementSubReportHeader
        }

        setIsDownloadPdf(true);


        postAndDownloadReportFile(apiUrl, data, getFileName(groupedByPeriod, 'pdf'), () => {
                enqueueSnackbar("Sucesso ao baixar o PDF", {variant: 'success'});
                setIsDownloadPdf(false);
            }, (error) => {
                enqueueSnackbar("Erro ao baixar o PDF " + error, {variant: 'error'});
                setIsDownloadPdf(false);
            },
            () => {
                enqueueSnackbar("Dados não encontrados para esse período", {variant: 'warning'});
                setIsDownloadPdf(false);
            }
        );

    }

    const handleCsvDownloadManagementReportInverter = () => {
        const apiUrl = `api/management-data/inverter/csv/${groupedByPeriod}`;

        const data = {
            equipmentIdsList: checkedInverters
                .filter(entity => entity.checked)
                .map(entity => (entity?.data as { id: number }).id),
            startDateTime: format(new Date(startDateTime), 'yyyy-MM-dd') + 'T00:00:00',
            endDateTime: LocalDateTimeFormatISO(endDateTime)
        };

        setIsDownloadCsv(true);
        constructedPostAndDownloadFile(apiUrl, data);
    }

    const handleExcelDownloadManagementReportInverter = () => {
        const apiUrl = `api/management-data/inverter/excel/${groupedByPeriod}`;

        const data = {
            equipmentIdsList: checkedInverters
                .filter(entity => entity.checked)
                .map(entity => (entity?.data as { id: number }).id),
            startDateTime: format(new Date(startDateTime), 'yyyy-MM-dd') + 'T00:00:00',
            endDateTime: LocalDateTimeFormatISO(endDateTime)
        };
        genericExcelDownload(apiUrl, data, groupedByPeriod);
    }



    const handleCsvDownload = () => {
        const apiUrl = `api/management-data/power-station/csv/${groupedByPeriod}`;

        const data = {
            powerStationIdsList: checked
                .filter(entity => entity.checked)
                .map(entity => (entity?.data as { id: number }).id),
            startDateTime: format(new Date(startDateTime), 'yyyy-MM-dd') + 'T00:00:00',
            endDateTime: LocalDateTimeFormatISO(endDateTime)
        };

        setIsDownloadCsv(true);

        constructedPostAndDownloadFile(apiUrl, data);
    }

    const handleCsvDownloadManagementReportSkid = () => {
        const apiUrl = `api/management-data/skid/csv/${groupedByPeriod}`;

        const data = {
            skidIdsList: checkedSkids
                .filter(entity => entity.checked)
                .map(entity => (entity?.data as { id: number }).id),
            startDateTime: format(new Date(startDateTime), 'yyyy-MM-dd') + 'T00:00:00',
            endDateTime: LocalDateTimeFormatISO(endDateTime)
        };

        setIsDownloadCsv(true);

        constructedPostAndDownloadFile(apiUrl, data);
    }

    function constructedPostAndDownloadFile(apiUrl: string, data:any) {
        postAndDownloadReportFile(
            apiUrl,
            data,
            getFileName(groupedByPeriod, 'csv'),
            () => {
                enqueueSnackbar("Sucesso ao baixar o CSV", {variant: 'success'});
                setIsDownloadCsv(false);
            },
            (error) => {
                enqueueSnackbar("Erro ao baixar o  CSV " + error, {variant: 'error'});
                setIsDownloadCsv(false);
            },
            () => {
                enqueueSnackbar("Dados não encontrados para esse período", {variant: 'warning'});
                setIsDownloadCsv(false);
            }
        );
    }

    const genericExcelDownload = (apiUrl: string, data: any, groupedByPeriod: string) => {
        setIsDownloadExcel(true);
        postAndDownloadReportFile(
            apiUrl,
            data,
            getFileName(groupedByPeriod, 'xlsx'),
            () => {
                enqueueSnackbar("Sucesso ao baixar o Excel", {variant: 'success'});
                setIsDownloadExcel(false);
            },
            (error) => {
                enqueueSnackbar("Erro ao baixar o  Excel " + error, {variant: 'error'});
                setIsDownloadExcel(false);
            },
            () => {
                enqueueSnackbar("Dados não encontrados para esse período", {variant: 'warning'});
                setIsDownloadExcel(false);
            }
        );
    }

    const handleExcelDownload = () => {
        const apiUrl = `api/management-data/power-station/excel/${groupedByPeriod}`;

        const data = {
            powerStationIdsList: checked
                .filter(entity => entity.checked)
                .map(entity => (entity?.data as { id: number }).id),
            startDateTime: format(new Date(startDateTime), 'yyyy-MM-dd') + 'T00:00:00',
            endDateTime: LocalDateTimeFormatISO(endDateTime)
        };
        genericExcelDownload(apiUrl, data, groupedByPeriod);
    }

    const handleExcelDownloadManagementReportSkid = () => {
        const apiUrl = `api/management-data/skid/excel/${groupedByPeriod}`;

        const data = {
            skidIdsList: checkedSkids
                .filter(entity => entity.checked)
                .map(entity => (entity?.data as { id: number }).id),
            startDateTime: format(new Date(startDateTime), 'yyyy-MM-dd') + 'T00:00:00',
            endDateTime: LocalDateTimeFormatISO(endDateTime)
        };
        genericExcelDownload(apiUrl, data, groupedByPeriod);
    }

    function getOnClickByType(type: string) {
        if (type === "excel") {
            if (typeManagement === "powerStation") {
                return handleExcelDownload;
            }
            if (typeManagement === "skid") {
                return handleExcelDownloadManagementReportSkid;
            }
            return handleExcelDownloadManagementReportInverter;
        }

        if (type === "csv") {
            if (typeManagement === "powerStation") {
                return handleCsvDownload;
            }
            if (typeManagement === "skid") {
                return handleCsvDownloadManagementReportSkid;
            }
            return handleCsvDownloadManagementReportInverter;
        }
        if (typeManagement === "overview") {
            return handlePdfDownloadGraphicalManagementReport;
        }

        return handlePdfDownload;
    }

    useEffect(() => {
        if(subHeader?.data) {
            setSubHeaderList(subHeader.data as SubReportHeader | SubReportHeaderBySkid | SubReportHeaderByEquipmentInverter);
        }
    },[subHeader.isSuccess])

    useEffect(() => {
        if (!subHeaderList) {
            setDataShuttle([]);
            return;
        }
        if (typeManagement === "powerStation" || typeManagement === "overview") {
            setDataShuttle(buildForPowerStation(subHeaderList as SubReportHeader));
        } else if (typeManagement === "skid") {
            setDataShuttle(buildForSkid(subHeaderList as SubReportHeaderBySkid));
        } else if (typeManagement === "inverter") {
            setDataShuttle(buildForEquipment(subHeaderList as SubReportHeaderByEquipmentInverter));
        }
    }, [subHeaderList, typeManagement]);

    const handleListRight = (value:SubHeader[]) => {
        if(value) {
            // Inicializa todas as propriedades do tipo SubReportHeader com null
            let newData: SubReportHeader = {
                id: 0,
                generatedEnergyName: null,
                injectedEnergyName: null,
                expectedInjectedEnergyName: null,
                yieldFieldName: null,
                expectedYieldName: null,
                capacityFactorName: null,
                irradianceName: null,
                expectedIrradianceName: null,
                satelitalIrradianceName: null,
                availabilityName: null,
                totalAvailabilityName: null,
                temperatureName: null,
                performanceRatioName: null,
                expectedPerformanceRatioName: null,
                generationLossesName: null,
                generatedEnergyDeviationName: null,
                injectedEnergyDeviationName: null,
                yieldDeviationName: null,
                irradiationDeviationName: null,
                performanceRatioDeviationName: null,
                performanceRatioRawName: null,
                operationAvailabilityName: null,
                yieldRateName: null,
                irradiationGhiName:null,
                expectedEnergyCorrectedByIrradiationName: null,
                clippingLossesName: null,
                poairradiationClippingName: null,
                dinName: null,
                dexName: null,
            };

            value.forEach(element => {
                if(element.prop in newData){
                    // @ts-ignore
                    newData[element.prop] = element.name;
                }
            });
                if(typeManagement === "powerStation") {
                
                    let apiUrl;
                    switch (groupedByPeriod) {
                        case "year":
                            apiUrl = `api/management-data/power-station/pdf/year`
                            break;
                        case "month":
                            apiUrl = `api/management-data/power-station/pdf/month`
                            break;
                        case "week":
                            apiUrl = `api/management-data/power-station/pdf/week`
                            break;
                        default:
                            apiUrl = `api/management-data/power-station/pdf/day`
                    }

                    const montedUrl: Array<MyElement> = checked;

                    const params = {
                        powerStationIds: montedUrl
                            .filter(entity => entity.checked) // filtra apenas objetos com "checked" definido como true
                            .map(entity => (entity?.data as { id: number }).id) // extrai os ids da propriedade "data"
                            .join(","),
                        startDateTime: format(new Date(startDateTime), 'yyyy-MM-dd') + 'T00:00:00',
                        endDateTime: LocalDateTimeFormatISO(endDateTime),

                    };
                    const managementSubReportHeader= newData
                    setIsDownloadPdf(true);

                    downloadReportFile(apiUrl,
                        params,
                        'relatoriodegestao.pdf',
                        () => {
                            enqueueSnackbar("Sucesso ao baixar o PDF por usina", {variant: 'success'});
                            setIsDownloadPdf(false);
                            handleCloseModal();
                        },
                        (error) => {
                            enqueueSnackbar("Erro ao baixar o  PDF por usina " + error, {variant: 'error'});
                            setIsDownloadPdf(false);
                        },
                        () => {
                            enqueueSnackbar("Dados não encontrados para esse período", {variant: 'warning'});
                            setIsDownloadPdf(false);
                            handleCloseModal();
                        }
                        ,
                        managementSubReportHeader
                    );
                } else if(typeManagement === "skid") {
                    handlePdfDownloadManagementReportSkid(newData);
                    handleCloseModal();
                } else {
                    handlePdfDownloadManagementReportInverter(newData);
                    handleCloseModal();
                }
        }
    }

    const contentPagePaddingTop = useAppSelector((state: any) => state.layout.contentPagePaddingTop);

    return (
        <Grid item padding={1} xs={12}>
            <ACard title="Relatório de Gestão">
                <Typography variant="subtitle1" gutterBottom component="div">
                    Relatório de Gestão:
                </Typography>
                <Box>
                    <RadioGroup
                        sx={{display: "inline", ml: 3}}
                        row
                        name="typeManagement"
                        value={typeManagement}
                        onChange={handleTypeManagement}
                    >
                        <FormControlLabel value="overview" control={<Radio/>} label="Resumo Geral"/>
                        <FormControlLabel value="powerStation" control={<Radio/>} label="Por usina"/>
                        <FormControlLabel value="skid" control={<Radio/>} label="Por skid"/>
                        <FormControlLabel value="inverter" control={<Radio/>} label="Por inversor"/>
                    </RadioGroup>
                </Box>
                <Box component="fieldset"
                     sx={{borderColor: 'transparent', padding: '0 0 16px 0', mt: '8px', mb: '16px'}}>
                    <div>
                        <FormControl sx={{m: 1, width: 300}}>
                            <InputLabel
                                id="demo-multiple-checkbox-label"
                            >
                                Usina(s)
                            </InputLabel>
                            <Select
                                labelId="demo-multiple-checkbox-label"
                                id="demo-multiple-checkbox"
                                multiple
                                value={checked.filter(item => item.checked).map(item => item.label)}
                                input={<OutlinedInput label="Usina(s)"/>}
                                renderValue={(selected) => selected.join(', ')}
                            >
                                <MenuItem value="Todos">
                                    <Checkbox
                                        checked={checkedAll}
                                        onChange={handleChangeAllCheckbox}
                                    />
                                    <ListItemText primary="Todos"/>
                                </MenuItem>
                                {checked.map((nameObject, index) => (
                                    <MenuItem
                                        key={nameObject.label}
                                        value={nameObject.label}
                                        color={"default"}
                                    >
                                        <Checkbox
                                            checked={nameObject.checked}
                                            onChange={(e) => handleChangeElementCheckbox(e, index)}
                                        />
                                        <ListItemText primary={nameObject.label}/>
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        {typeManagement !== "overview" && (
                        <FormControl sx={{m: 1, width: 300}}>
                            <InputLabel
                                id="demo-multiple-checkbox-label"
                            >
                                Skid(s)
                            </InputLabel>
                            <Select
                                labelId="demo-multiple-checkbox-label"
                                id="demo-multiple-checkbox"
                                multiple
                                disabled={typeManagement === "powerStation"}
                                value={checkedSkids.filter(item => item.checked).map(item => item.name)}
                                input={<OutlinedInput label="Skid(s)"/>}
                                renderValue={(selected) => selected.join(', ')}
                            >
                                <MenuItem value="Todos">
                                    <Checkbox
                                        checked={checkedAllSkid}
                                        onChange={handleChangeAllSkidCheckbox}
                                    />
                                    <ListItemText primary="Todos"/>
                                </MenuItem>
                                {checkedSkids.map((nameObject, index) => (
                                    <MenuItem
                                        key={nameObject.name}
                                        value={nameObject.name}
                                    >
                                        <Checkbox
                                            checked={nameObject.checked}
                                            onChange={(e) => handleChangeSkidCheckbox(e, index)}
                                        />
                                        <ListItemText primary={nameObject.name}/>
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        )}
                        {typeManagement !== "overview" && (
                        <FormControl sx={{m: 1, width: 300}}>
                            <InputLabel
                                id="demo-multiple-checkbox-label"
                            >
                                Equipamento(s)
                            </InputLabel>
                            <Select
                                labelId="demo-multiple-checkbox-label"
                                id="demo-multiple-checkbox"
                                multiple
                                disabled={typeManagement === "powerStation" || typeManagement === "skid"}
                                value={checkedInverters.filter(item => item.checked).map(item => item.name)}
                                input={<OutlinedInput label="Equipamento(s)"/>}
                                renderValue={(selected) => selected.join(', ')}
                                MenuProps={MenuProps}
                            >
                                <MenuItem value="Todos">
                                    <Checkbox
                                        checked={checkedAllInverter}
                                        onChange={handleChangeAllInverterCheckbox}
                                    />
                                    <ListItemText primary="Todos"/>
                                </MenuItem>
                                {checkedInverters.map((nameObject, index) => (
                                    <MenuItem
                                        key={nameObject.name}
                                        value={nameObject.name}
                                    >
                                        <Checkbox
                                            checked={nameObject.checked}
                                            onChange={(e) => handleChangeInverterCheckbox(e, index)}
                                            title={nameObject.name}
                                        />
                                        <ListItemText primary={nameObject.name}/>
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        )}
                    </div>
                </Box>

                {typeManagement !== "overview" && (
                <Box>
                    <Typography variant="subtitle1" gutterBottom component="div">
                        Agrupamento:
                    </Typography>
                    <Box>
                        <RadioGroup
                            sx={{display: "inline", ml: 3}}
                            row
                            name="groupedByPeriod"
                            value={groupedByPeriod}
                            onChange={handlePeriodChange}
                        >
                            <FormControlLabel value="day" control={<Radio/>} label="Diário"/>
                            <FormControlLabel value="week" control={<Radio/>} label="Semanal"/>
                            <FormControlLabel value="month" control={<Radio/>} label="Mensal"/>
                            <FormControlLabel value="year" control={<Radio/>} label="Anual"/>
                        </RadioGroup>
                    </Box>
                </Box>
                )}
                <Box component="fieldset"
                     sx={{borderColor: 'transparent', padding: '0 0 16px 0', mt: '8px', mb: '16px'}}>
                    <Typography variant="subtitle1" gutterBottom component="div">
                        Período:
                    </Typography>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                    {typeManagement !== "overview" && (
                        <DatePicker
                            label="Início"
                            inputFormat="DD/MM/YYYY"
                            value={startDateTime}
                            onChange={(newValue: Date | null) => {
                                setStartDateTime(newValue ?? handleStartDateTime(new Date()));
                            }}
                            renderInput={(params) => <TextField {...params} />}
                        />
                    )}
                        <DatePicker
                            label={typeManagement !== "overview" ? "Fim" :"Até"}
                            inputFormat="DD/MM/YYYY"
                            value={endDateTime}
                            onChange={(newValue) => {
                                setEndDateTime(newValue ?? new Date());
                            }}
                            renderInput={(params) => <TextField {...params} />}
                        />
                    </LocalizationProvider>
                </Box>
                <Box>
                    {/* Botão de Download do PDF */}
                    {
                        isDownloadPdf ?
                            <LoadingButton
                                loading
                                loadingPosition="end"
                                endIcon={<SaveIcon sx={{fontSize: 20}}/>}
                            >
                                Carregando..
                            </LoadingButton>
                            :
                            <Button
                                variant="contained"
                                color="primary"
                                disabled={!isPdfActionEnabled}
                                onClick={getOnClickByType("pdf")}
                                startIcon={<Download/>}
                                sx={{mr: 1}}
                            >
                                PDF
                            </Button>
                    }
                    {/* Botão de Download do CSV */}
                    {typeManagement !== "overview" && (

                        isDownloadCsv ?
                            <LoadingButton
                                loading
                                loadingPosition="end"
                                endIcon={<SaveIcon sx={{fontSize: 20}}/>}
                            >
                                Carregando..
                            </LoadingButton>
                            :
                            <Button
                                variant="contained"
                                color="primary"
                                disabled={!isAuthorizedToSearchByCsv}
                                onClick={getOnClickByType("csv")}
                                startIcon={<Download/>}
                                sx={{mr: 1}}
                            >
                                CSV
                            </Button>
                    )}
                    {/* Botão de Download do Excel */}
                    { typeManagement !== "overview" && (

                        isDownloadExcel ?
                            <LoadingButton
                                loading
                                loadingPosition="end"
                                endIcon={<SaveIcon sx={{fontSize: 20}}/>}
                            >
                                Carregando..
                            </LoadingButton>
                            :
                            <Button
                                variant="contained"
                                color="primary"
                                disabled={!isAuthorizedToSearchByExcel}
                                onClick={getOnClickByType("excel")}
                                startIcon={<Download/>}
                                sx={{mr: 1}}
                            >
                                Excel
                            </Button>
                    )}
                </Box>
                <Modal
                    open={open}
                    onClose={handleCloseModal}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={{ 
                        position: 'absolute',
                        top: '55%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: window.innerWidth > 1440 ? '50%' : '85%',
                        height: '85%',
                        bgcolor: 'background.paper',
                        border: '1px solid #666',
                        borderRadius: 5
                    }}>
                        <ACard
                            title="Montar relatório em PDF"
                            subTitle="Selecione 14 item para gerar o relatório"
                            styleProps={{
                                cardStyle: {overflow:"auto", padding: 2, height: '100%'}
                            }}
                        >

                            <SelectAllTransferList data={dataShuttle} maxItem={14} handleListRight={handleListRight}/>
                        </ACard>
                    </Box>
                </Modal>
               
            </ACard>
        </Grid>
    );
}


export default function ManagementReportPage() {
    const queryClient = useMemo(() => new QueryClient(), []);

    return (
        <QueryClientProvider client={queryClient}>
            <ManagementReport />
        </QueryClientProvider>
    );
}